export default "__VITE_ASSET__DMd$kRn2__"